import { useRef } from 'react';
import { useMotionValue, useSpring, useTransform } from 'motion/react';

interface TiltOptions {
  maxRotation?: number;
  stiffness?: number;
  damping?: number;
}

export const useTiltEffect = (options: TiltOptions = {}) => {
  const { maxRotation = 12, stiffness = 300, damping = 30 } = options;
  const ref = useRef<HTMLDivElement>(null);

  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const rotateX = useSpring(
    useTransform(mouseY, [-0.5, 0.5], [maxRotation, -maxRotation]),
    { stiffness, damping },
  );
  const rotateY = useSpring(
    useTransform(mouseX, [-0.5, 0.5], [-maxRotation, maxRotation]),
    { stiffness, damping },
  );
  const glowX = useTransform(mouseX, [-0.5, 0.5], [0, 100]);
  const glowY = useTransform(mouseY, [-0.5, 0.5], [0, 100]);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    mouseX.set((e.clientX - rect.left) / rect.width - 0.5);
    mouseY.set((e.clientY - rect.top) / rect.height - 0.5);
  };

  const handleMouseLeave = () => {
    mouseX.set(0);
    mouseY.set(0);
  };

  return { ref, rotateX, rotateY, glowX, glowY, handleMouseMove, handleMouseLeave };
};
